import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
Swiper.use([Navigation, Pagination]);

import { mediaQueryBreakpointMD, mediaQueryBreakpointSM } from '../Utils/Utils';

const ACFBlockAmbassadorsSlideshow = (blockElem) => {

	const loop = blockElem.getAttribute('data-loop') === 'true';
	const numSlides = blockElem.querySelectorAll('.swiper .swiper-slide').length;
	//console.log('numSlides',numSlides);

	new Swiper(blockElem.querySelector('.swiper'), {
		direction: 'horizontal',
		loop: loop,
		slidesPerView: 1.05,
		spaceBetween: 20,
		centeredSlides: true,

		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},

		pagination: {
			el: '.swiper-pagination',
			type: 'fraction',
			clickable: false,

			renderFraction: function (currentClass, totalClass) {
				return '<span class="' + currentClass + '"></span><span>/</span>' + '<span class="' + totalClass + '"></span>'; }
		},

		breakpoints: {
			[mediaQueryBreakpointSM]: {
				slidesPerView: 'auto',
				spaceBetween: 68,
				initialSlide: !loop ? 1 : 0,
			},
			[mediaQueryBreakpointMD]: {
				slidesPerView: numSlides < 4 ? numSlides : 4 ,
				spaceBetween: 68,
				initialSlide: !loop ? 1 : 0,
			},
		}
	});
};

export default ACFBlockAmbassadorsSlideshow;